import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from 'react';
import './timeline.scss';
import AssetService from '../../../utils/asset-load';
import ProgressBar from '../progress-bar/progress-bar';
import Image from '../../shared/images/Image';
import {
  Route,
  Switch,
  useHistory,
  Redirect,
  useLocation,
} from 'react-router-dom';
import ReflectionQuestions from '../../shared/reflection-questions/reflection-questions';
import VideoPlayer from '../../shared/video-player/video-player';
import NavButtons from '../nav-buttons/nav-buttons';
import Static from '../../shared/static-content/static-content';
import Quiz from '../../shared/quiz/quiz';
import { gsap } from 'gsap';
import { Context } from '../../../context';
import DevelopmentTip from '../../shared/development-tip/DevelopmentTip';
import ClickReveal from '../../activities/ClickReveal/ClickReveal';
import FaceSurvey from '../../shared/face-survey/FaceSurvey';
import PlanIt from '../../practice/PlanIt';
import VoiceOver from '../../shared/voice-over/VoiceOver';
import './page-order.scss';
// import DragonDrop from "../../shared/DragonDrop/DragonDrop";
import { DragonDropWrapper } from '../../shared/DragonDrop/DragonDrop';
import Badge from '../../shared/badges/badge';
import Handout from '../../shared/handouts/Handout';
import { PractieChecklistWrapper } from '../../practice-checklist/PractieChecklistWrapper';
import { Tricks } from '../../shared/tricks/Tricks';
import Activity from '../../activities/Activity';
import PostSurvey from '../../course/Overview/PostSurvey';
import ReframingActivity from '../../admin-page/pages/facilitator/pages/mod-3/ReframingActivity';
function Timeline(props) {
  const context = useContext(Context);

  const [timelineData, setTlData] = useState(null);
  const [progress, setProgress] = useState(0);
  const [links, setLinks] = useState(['/']);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [currentModule, setCurrentModule] = useState(null);
  const location = useLocation();
  const [bodyHeight, setBodyHeight] = useState();
  const [videoWatched, setVideoWatched] = useState(true);
  const [curIndex, setCurIndex] = useState(0);
  // eslint-disa  ble-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (timelineData) {
      const index = timelineData.findIndex((x) => {
        return x.url === context.state.curModLink;
      });

      if (context.state.curSlide) {
        setCurIndex(context.state.curSlide);
      } else {
        setCurIndex(0);
      }
    }
    return () => {
      context.setCurSlide(0);
    };
  }, [context.state.curModLink]);

  useEffect(() => {
    if (props.path.url === window.location.pathname) {
      handleDataFetch();
    } else {
      history.push(props.path.url);
      handleDataFetch();
    }
  }, [props.path, context.state.curModLink]);

  useEffect(() => {
    setProgress(links.indexOf(window.location.pathname));
  }, [links]);

  useEffect(() => {
    setProgress(links.indexOf(location.pathname));
  }, [location]);

  useEffect(() => {
    context.setTimelineProgress(progress, location.pathname);
  }, [progress]);

  useEffect(() => {
    setCurIndex(context.state.curSlide);
  }, [context.state.curSlide]);

  useEffect(() => {
    const currentSectionIndex = props.allLinks.findIndex(
      (link) => link.url === props.path.url,
    );

    if (currentSectionIndex === -1) {
      return;
    }

    if (context.state.curModIndex !== props.modIndex) {
      context.setSidebarModuleOpen(props.modIndex);
    }

    if (context.state.curSectionIndex !== currentSectionIndex) {
      context.setCurSectionIndex(currentSectionIndex);
    }

    if (!context.state.linkIndexes.length) {
      return;
    }

    const savedSectionIndex = context.state.linkIndexes[props.modIndex] ?? 0;

    if (savedSectionIndex < currentSectionIndex) {
      context.setUpdateLinkIndexes(props.modIndex, currentSectionIndex);
    }
  }, [
    context,
    context.state.curModIndex,
    context.state.curSectionIndex,
    context.state.linkIndexes,
    props.allLinks,
    props.modIndex,
    props.path.url,
  ]);

  //this is called whenever the props path is changed
  const handleDataFetch = () => {
    if (context.state.curSlide === 0) {
      setCurIndex(0);
    }
    let urlArray = props.path.url.split('/');

    let dataIndex = urlArray.indexOf('timeline') + 1;

    let currentModule = urlArray[urlArray.indexOf('timeline') - 1];

    let data = AssetService.getTimeline(urlArray[dataIndex], currentModule);

    setTlData(data);
    let array = [];
    data.map((item) => {
      array.push(item.url);
    });
    setLoading(false);
    setLinks(array);
  };

  const handleProgressState = (increment) => {
    context.setCurSlide(0);
    let array = [];
    props.allLinks.map((object) => {
      array.push(object.url);
    });
    if (increment) {
      // continue
      if (progress < links.length - 1) {
        // progress to the next timeline page

        fadeContent(links[progress + 1]);
        setProgress(progress + 1);
      } else {
        if (props.allLinks.length - 1 === context.state.curSectionIndex) {
          // last section in module
          if (props.nextData !== undefined) {
            // progress to the next module
            fadeContent(props.nextData.links[0].url);
            const removedUrl = context.state.disabledArray.find(
              (url) => url === `/course/module${context.state.curModIndex + 2}`,
            );

            context.setCurModIndex(context.state.curModIndex + 1);

            context.updateDisabledArray(removedUrl);
            if (
              context.state.curModIndex === context.state.lastVisitedModIndex
            ) {
              context.setLastVisitedModIndex(
                context.state.lastVisitedModIndex + 1,
              );
            }
            // set the current section to 0 because it starts a new section in a new module
            context.setCurSectionIndex(0);
          } else {
            // go back to default page
            fadeContent('/course/overview');
          }
        } else {
          // progress to the next section
          setCurIndex(0);
          fadeContent(array[context.state.curSectionIndex + 1]);
          context.setCurSectionIndex(context.state.curSectionIndex + 1);
          // update linkIndexes value only when condition met lastVisitedModIndex value
          // otherwise user can visit the pages they visited
          if (
            context.state.curSectionIndex ===
              context.state.linkIndexes[context.state.curModIndex] &&
            context.state.linkIndexes[context.state.curModIndex] <=
              context.state.maxLengthLinkArray[context.state.curModIndex] - 1
          ) {
            context.setUpdateLinkIndexes(
              context.state.curModIndex,
              context.state.curSectionIndex + 1,
            );
          }
        }
        setProgress(progress + 1);
      }
    } else {
      // back
      if (progress > 0) {
        // go back in the timeline
        fadeContent(links[progress - 1]);
        setProgress(progress - 1);
      } else if (progress === 0) {
        // go back a section
        if (array[context.state.curSectionIndex - 1] !== undefined) {
          let urlArray = array[context.state.curSectionIndex - 1].split('/');
          let dataIndex = urlArray.indexOf('timeline') + 1;
          let currentModule = urlArray[urlArray.indexOf('timeline') - 1];
          let data = AssetService.getTimeline(
            urlArray[dataIndex],
            currentModule,
          );

          setTlData(data);
          context.setCurSectionIndex(context.state.curSectionIndex - 1);
          fadeContent(data[data.length - 1].url);
        } else if (props.lastData !== undefined) {
          // go back a module
          if (props.lastData.links.length > 0) {
            let lastItemarray = [];
            props.lastData.links.map((object) => {
              lastItemarray.push(object.url);
            });
            let urlArray = lastItemarray[lastItemarray.length - 1].split('/');
            let dataIndex = urlArray.indexOf('timeline') + 1;
            let currentModule = urlArray[urlArray.indexOf('timeline') - 1];
            let data = AssetService.getTimeline(
              urlArray[dataIndex],
              currentModule,
            );
            setTlData(data);
            context.setCurSectionIndex(lastItemarray.length - 1);
            context.setSidebarModuleOpen(context.state.curModIndex - 1);
            fadeContent(data[data.length - 1].url);
          }
        }
      }
    }
  };

  const fadeContent = (link) => {
    gsap
      .to('.fadeIt', { opacity: 0, duration: 0.3 })
      .then(() => {
        history.push(link);
        window.scrollTo(0, 0);
      })
      .then(() => {
        gsap.to('.fadeIt', { opacity: 1, duration: 0.3 });
      });
  };

  const [size, setSize] = useState();

  return (
    <>
      {loading ? (
        <div>loading...</div>
      ) : (
        <div className='timeline-wrap'>
          <div className='top-section'>
            <div className='sub-section-title'>
              <p>{props.path.title}</p>
            </div>
            {timelineData ? <ProgressBar links={timelineData} /> : <></>}
          </div>

          <div className='slide-wrap'>
            <div className='fade-content' id='fade'>
              <Switch>
                {timelineData ? (
                  timelineData.map((item, i) => {
                    return (
                      <Route path={item.url} key={item.url}>
                        <TimelineBody
                          item={item}
                          setSize={setSize}
                          setVideoWatched={setVideoWatched}
                        />
                        {timelineData && !loading ? (
                          <NavButtons
                            progress={progress}
                            handleProgress={(increment) =>
                              handleProgressState(increment)
                            }
                            submitID={item.submitID}
                            links={links}
                            size={size}
                            videoWatched={videoWatched}
                          />
                        ) : (
                          <></>
                        )}
                      </Route>
                    );
                  })
                ) : (
                  <> no data</>
                )}
                {timelineData ? (
                  <>
                    <Redirect
                      from={props.parentRoute}
                      to={
                        timelineData[
                          curIndex && timelineData.length > curIndex
                            ? curIndex
                            : 0
                        ].url
                      }
                    />
                  </>
                ) : (
                  <></>
                )}
              </Switch>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const TimelineBody = ({ item, setSize, setVideoWatched }) => {
  // const [getHeight, setGetHeight] = useState('');
  let ref = useRef();
  const updateDimensions = () => {
    if (ref.current) setSize(ref.current.scrollHeight);
  };

  useEffect(() => {
    if (!item.video) {
    }
  }, [item]);

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    setSize(ref.current.clientHeight);
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  return (
    <div id='fadeIt' className='fadeIt' ref={ref}>
      <div className={`${item.identifier ? item.identifier : ''}`}>
        {item.title ? <h2 className='title'>{item.title}</h2> : <></>}
        {item.static ? (
          <div className='static-wrap'>
            <Static data={item.static} />
          </div>
        ) : (
          <></>
        )}
        {item.video ? (
          item.video.map((item, i) => (
            <div className='video-parent' key={i}>
              <div className='video-wrap'>
                <VideoPlayer
                  source={item.source}
                  setVideoWatched={setVideoWatched}
                />
              </div>
              {item.reflection ? (
                <div className='reflections-questions-wrap'>
                  <ReflectionQuestions
                    className=''
                    dynamic={item.dynamic ? item.dynamic : ''}
                    questions={item.reflection}
                    questionsIntro={
                      item.questionsIntro ? item.questionsIntro : ''
                    }
                  />
                </div>
              ) : (
                <></>
              )}
              {item.voiceOver ? (
                <div className='voiceOver'>
                  <VoiceOver content={item.voiceOver} />
                </div>
              ) : (
                <></>
              )}
            </div>
          ))
        ) : (
          <></>
        )}

        {item.quiz ? (
          <div className='quiz-wrap'>
            <Quiz path={item.quiz} submitID={item.submitID} />
          </div>
        ) : (
          <></>
        )}
        {item.planIt ? (
          <PlanIt
            submitID={item.submitID}
            path={item.planIt}
            identifier={item.identifier}
            content={item.practiceContent}
            badge={item.activityBadge}
          />
        ) : (
          <></>
        )}
        {item.customActivity === 'reframing' ? (
          <div className='click-reveal-wrap'>
            <ReframingActivity
              badge={item.activityBadge}
              showCompletionNotice
              showIntro={false}
            />
          </div>
        ) : item.clickReveal ? (
          <div className='click-reveal-wrap'>
            <ClickReveal
              path={item.clickReveal}
              badge={item.activityBadge}
              // setGetHeight={setGetHeight}
            />
          </div>
        ) : (
          <></>
        )}
        {item.voiceOver ? <VoiceOver content={item.voiceOver} /> : <></>}
        {item.DragonDrop && (
          <DragonDropWrapper
            content={item.DragonDrop}
            badge={item.activityBadge}
          />
        )}
        {item.practiceChecklist && (
          <PractieChecklistWrapper
            module={item.practiceChecklist}
            practiceBadge={item.practiceBadge}
          />
        )}
        {item.image && <Image number={item.image} />}
        {item.faceSurvey && <FaceSurvey />}
        {item.postSurvey && <PostSurvey />}
        {item.activity && (
          <Activity
            submitID={item.submitID}
            content={item.activity}
            badge={item.activityBadge}
            identifier={item.identifier}
          />
        )}
        {item.badge && (
          <div className='handout-wrap'>
            <Badge content={item.badge} TEST />
          </div>
        )}
        {item.devTip ? (
          <div className='devTip-wrap'>
            <DevelopmentTip content={item.devTip} mod={item.mod} />
          </div>
        ) : (
          <></>
        )}
        {item.handout && (
          <div className='handout-wrap'>
            <Handout content={item.handout} />
          </div>
        )}

        {item.trick ? <Tricks content={item.trick} /> : <></>}
      </div>
    </div>
  );
};

export default Timeline;
